import { render, staticRenderFns } from "./PasoSeleccion.vue?vue&type=template&id=4c79c8f4"
import script from "./PasoSeleccion.vue?vue&type=script&setup=true&lang=js"
export * from "./PasoSeleccion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports